import Header from "./Header";
import Navigation from "./Navigation";
import classNames from "classnames";
import { omit } from "lodash";
import { useAppBgStyle } from "@/hooks/App/useAppBgStyle";

interface BasicHeaderProps {
  onRequestMqsInterstitial?: () => void;
}

const BasicHeader: React.FC<BasicHeaderProps> = ({ onRequestMqsInterstitial }) => {
  const appBgStyles = useAppBgStyle();

  return (
    <div
      className={classNames(["sticky top-0 w-full z-9999 max-w-360"])}
      style={omit(appBgStyles, ["position", "height", "zIndex", "width"])}
    >
      <div className={classNames(["flex flex-col justify-start items-start color-[var(--app-text-04)] z-99"])}>
        <Header />
        <Navigation onRequestMqsInterstitial={onRequestMqsInterstitial} />
      </div>
    </div>
  );
};
export default BasicHeader;
